var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useLucidSdk } from '#context';
import { FilespacesKeyFactory } from '#query-hooks';
export const useFilespaceRename = ({ filespaceId, workspaceId }, { onError, onSuccess }) => {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: (params) => {
            return lucidSdk
                .workspaceClient(workspaceId)
                .updateFilespace(filespaceId, {
                name: params.name,
            });
        },
        onSuccess: async () => {
            try {
                /// Update filespace data
                await queryClient.refetchQueries({
                    queryKey: FilespacesKeyFactory.exact(workspaceId, filespaceId),
                });
            }
            finally {
                if (typeof onSuccess === 'function') {
                    onSuccess();
                }
            }
        },
        onError: (err) => {
            if (typeof onError === 'function') {
                onError(err);
            }
        },
        networkMode: 'always',
    });
    return { mutation };
};
_react_refresh_temp_1(useFilespaceRename, "s074ag8lSG2K0z8InO7Yl75Raxc=", false, () => [useLucidSdk, useQueryClient, useMutation]);
